import React from "react";
import "./AboutStyle.css";

function About() {
    return (
    <main>
        <div id="aboutUs">
        <h2>About Us</h2>
        </div>
        <div className="about">
            <div>Welcome to the Bouquet Now! We are a certified flower dealer and lookin to slang some pollen at ya. We're a group of four students passionate about flowers, nature, and spreading color! One day while hiking through the forest, we couldn't help but notice the amazing aroma of all the wildflowers. We thought it would be great to bring that experience to everyone. So we did just that, let everyone stop to smell the roses.</div>
            <div>
            We aren’t dandelion when we say that our arrangements are simply iris-istible! It is our guarantee, and if you aren’t head clover heels for your arrangement, simply let us know and we will make it right.</div>
            <div>
            We have arrangements for any occasion, from: “We should put our tulips together”, and “I’m so thorny”, to “Every daisy is better because of you”, from “I’m proud to be yorchid”, to “Get well soon, don’t crocus”. Don’t worry if none of our listed occasions meet your needs, we do custom orders as well! </div>
            <div>
            We love party planning and appreciate our fellow planners, so if you need to plan an event, please reach out to schedule an appointment today! If you are in a pinch, and aren’t scared to get a little dirty give us a call today and we will see what we can do. </div>
            <div>
            We do deliveries! For regular small-batch deliveries we stay within a 30-mile radius. For large events we will extend our radius out to 100 miles.
            </div>  
        </div>
    </main>
    )
}

export default About;